/**
 * Onboarding animation asset paths — the single source of truth so the preload
 * (onboarding layout `head()`) and the render sites (verify-email step, the
 * "You're all set" modal) always reference the exact same URL, which is what lets
 * the prefetch warm the HTTP cache the later fetch reuses.
 *
 * Both are dotLottie (`.lottie`) files served from `/public/animations`. They are
 * placeholders sourced online — swap the files in place (same path) to restyle.
 */

/** Calm decorative mark on the verify-email step (an envelope / secure-delivery motif). */
export const ONBOARDING_VERIFY_LOTTIE = '/animations/onboarding-verify.lottie';

/** Success checkmark shown in the "You're all set" completion modal. */
export const ONBOARDING_SUCCESS_LOTTIE = '/animations/onboarding-success.lottie';
